import { MarvColor, MarvColorPurple } from '@marv/types';
import { environment } from '@app/environment';
import { RetailerLogo } from '@app/components';
import { StoreDirectory, Store } from '@app/models';

export class StoreItemQuota {   
    quotaTotal: number;
    quotaRealized: number;
    quotaPlanned: number;
    quotaRemaining: number;
}

export class StoreItemScore {   
    name: string;
    score: number;
    color: MarvColor;
}

export class StoreItemSector {
    id: number;
    name: string;
}

export class StoreItemOperation {
    name: string;
    type: string;
    nbMissions: number;
}

export class StoreItem {
    id: number;
    retailer: string;
    logoRetailer: RetailerLogo;
    name: string;
    administrativeArea: string;
    zipCode: string;
    city: string;
    operations: Array<StoreItemOperation>;
    sector: StoreItemSector|null = null;
    scores: Array<StoreItemScore> = [];
    
    static FromStoreDirectory (storeDirectory: StoreDirectory): StoreItem{
        let storeItem = new StoreItem();
        storeItem.id = storeDirectory.id;
        storeItem.retailer = storeDirectory.retailer?.name;
        if(storeDirectory.retailer?.name){
            storeItem.logoRetailer = new RetailerLogo(storeDirectory.retailer.name);
        }
        storeItem.name = storeDirectory.name;
        storeItem.administrativeArea = storeDirectory.address?.administrativeArea;
        storeItem.zipCode = storeDirectory.address?.zipCode;
        storeItem.city = storeDirectory.address?.city;
        storeItem.operations = [];
        storeDirectory.liveOperations?.forEach(o => {
            storeItem.operations.push({
                name: o.name,
                type: o.typeOfMission,
                nbMissions: o.missionCount
            });
        });
        
        // A MODIFIER - A ajouter dans l'API
        /*
        let score =  Math.floor(Math.random() * (95 - 45) + 45) / 100;
        storeItem.scores.push({
            name: 'Score Merch',
            score: score,
            color: MarvColorPurple
        });
        */
        return storeItem;
    }
    
    static FromStore (store: Store): StoreItem{
        let storeItem = new StoreItem();
        storeItem.id = store.id;
        storeItem.retailer = store.retailerName;
        storeItem.logoRetailer = new RetailerLogo(store.retailerName);
        storeItem.name = store.name;
        storeItem.administrativeArea = store.address?.administrativeArea;
        storeItem.zipCode = store.address?.zipCode;
        storeItem.city = store.address?.city;
        if(store.customerSectorId && store.customersectorName){
            storeItem.sector = {
                id: store.customerSectorId,
                name: store.customersectorName
            };
        }
        storeItem.operations = [];
        // A MODIFIER - A àjouter dans l'API
        /*store.liveOperations?.forEach(o => {
            storeItem.operations.push({
                name: o.name,
                type: o.typeOfMission,
                nbMissions: o.missionCount
            });
        });*/
        
        // A MODIFIER - A ajouter dans l'API
        /*
        let score =  Math.floor(Math.random() * (95 - 45) + 45) / 100;
        storeItem.scores.push({
            name: 'Score Merch',
            score: score,
            color: MarvColorPurple
        });
        */
        return storeItem;
    }
}

